// External libraries
import gql from 'graphql-tag';

export const INSTALLMENT_OPTIONS_QUERY = gql`
  query InstallmentOptionsQuery(
    $buyerCountry: CountryCodes!
    $cardNumber: String!
    $cardType: CardIssuerType
    $token: String!
  ) {
    getInstallmentsForOnboardingFlows(
      buyerCountry: $buyerCountry
      cardNumber: $cardNumber
      cardType: $cardType
      token: $token
    ) {
      discount {
        amount {
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencySymbol
          currencyValue
        }
        percentage
      }
      monthlyPayment {
        currencyCode
        currencyFormat
        currencyFormatSymbolISOCurrency
        currencySymbol
        currencyValue
      }
      term
      totalCost {
        currencyCode
        currencyFormat
        currencyFormatSymbolISOCurrency
        currencySymbol
        currencyValue
      }
      totalConsumerFee {
        amount {
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencySymbol
          currencyValue
        }
        percentage
      }
      feeReferenceId
    }
  }
`;
